import { render } from "./TeamReportResultTeam2Page.vue?vue&type=template&id=f47963ac&scoped=true"
import script from "./TeamReportResultTeam2Page.vue?vue&type=script&lang=js"
export * from "./TeamReportResultTeam2Page.vue?vue&type=script&lang=js"

import "./TeamReportResultTeam2Page.vue?vue&type=style&index=0&id=f47963ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f47963ac"]])

export default __exports__